import { Icon } from "@cadmakers-ui/icons";
import React, { useState } from "react";
import { DateDisplay } from "../../../../Common";

import styles from "../../../Styles/DueDateDisplay.module.scss";

type Props = {
  dueDate?: Date;
  enableEdit: boolean;
  onClickEdit: () => void;
};

export const DueDateDisplay = (props: Props) => {
  const isOverdue = !!props.dueDate && props.dueDate < new Date();

  return (
    <>
      <div className={styles.dueDateWrapper}>
        {!props.dueDate && <span>Unset</span>}
        {props.dueDate && <DateDisplay date={props.dueDate} isOverdue={isOverdue} />}
        {props.enableEdit && (
          <Icon
            appName="GeneralLayout"
            assetName="POINTER_AddAnchor"
            className={styles.editIcon}
            title="Edit Due Date"
            onClick={props.onClickEdit}
          />
        )}
      </div>
    </>
  );
};
